module.exports = __webpack_public_path__ + "static/media/p11.942f1445.jpeg";